// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"theme_scrollbar__1R-lH"};